const LOGOS = [
  { src: "/logos/stripe.svg", alt: "Stripe", cls: "h-3.5" },
  { src: "/logos/visa.svg", alt: "Visa", cls: "h-5" },
  { src: "/logos/mastercard.svg", alt: "Mastercard", cls: "h-5" },
  { src: "/logos/amex.svg", alt: "American Express", cls: "h-5" },
  { src: "/logos/applepay.svg", alt: "Apple Pay", cls: "h-4" },
  { src: "/logos/googlepay.svg", alt: "Google Pay", cls: "h-4" },
];

export default function PaymentLogos({ className = "" }) {
  return (
    <div data-testid="payment-logos" className={`flex flex-wrap items-center gap-2 ${className}`}>
      {LOGOS.map((l) => (
        <span
          key={l.alt}
          className="inline-flex items-center justify-center bg-white rounded-md px-2 h-7 border border-black/5 shadow-sm"
        >
          <img src={l.src} alt={l.alt} className={`${l.cls} w-auto`} />
        </span>
      ))}
    </div>
  );
}
